//#region pirms mana laika
if ($('#back-to-top').length) {
    var scrollTrigger = 100, // px
        backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $('#back-to-top').addClass('show');
            } else {
                $('#back-to-top').removeClass('show');
            }

            if(scrollTop > $(document).outerHeight() - $('footer').outerHeight()- $(window).height() + $('#back-to-top').outerHeight() + 40){
                $('#back-to-top').addClass('white');
            } else {
                $('#back-to-top').removeClass('white');
            }
        };
    backToTop();
    $(window).on('scroll', function() {
        backToTop();
    });
    $('#back-to-top').on('click', function(e) {
        e.preventDefault();
        $('html,body').animate(
            {
                scrollTop: 0
            },
            700
        );
    });
}

function initSelects() {
    styleSelects();

    $(document).on('click', 'select.styled', function() {
        $(this).parent().focus();
    });

    $(document).on('click', '.select-value', function() {
        $(this).parent().focus();
    });

    $(document).on('click', '.select-options .option', function(e) {
        var wrap = $(this).parents('.select-wrap');
        var selectValue = wrap.find('.select-value');
        wrap.removeClass('clicked');
        selectValue.html($(this).html());
        wrap.find('select').val($(this).attr('data-value')).change();
        $('.option', wrap).removeClass('selected');
        $(this).addClass('selected');
        if ($(this).attr('data-default')) {
            selectValue.removeClass('selected');
        } else {
            selectValue.addClass('selected');
        }
        e.stopImmediatePropagation();
        e.stopPropagation();
    });

    $(document).on('keypress', '.select-options .option', function(e) {
        if (e.charCode == 13) {
            var wrap = $(this).parents('.select-wrap');
            var selectValue = wrap.find('.select-value');
            $('.option', wrap).removeClass('selected');
            $(this).addClass('selected');
            if ($(this).attr('data-default')) {
                selectValue.removeClass('selected');
            } else {
                selectValue.addClass('selected');
            }
            selectValue.html($(this).html());
            wrap.find('select').val($(this).attr('data-value')).change();
        }
    });

    $(document).on('focusin', '.select-wrap', function(e) {
        $(this).addClass('clicked');
        e.stopImmediatePropagation();
        e.stopPropagation();
    });

    $(document).on('focusout', '.select-wrap', function(e) {
        $(this).removeClass('clicked');
        e.stopImmediatePropagation();
        e.stopPropagation();
    });
    // find option by pressed keys
    var typingTimer;
    var doneTypingInterval = 700;
    var needle = '';

    $(document).on('keyup', '.select-wrap', function(e) {
        if (e.which == 27) {
            $(this).removeClass('clicked');
            return false;
        }

        needle += e.key;
        clearTimeout(typingTimer);
        selectWrap = $(this);

        typingTimer = setTimeout(function() {
            doneTyping(selectWrap);
        }, doneTypingInterval);
    });

    function doneTyping(selectWrap) {
        var opt = $('.option', selectWrap).filter(function() {
            var text = $(this).text().toLowerCase().replace(/\s/g, '');
            needle = needle.replace(/\s/g, '');
            return text.indexOf(needle) === 0;
        });
        if (opt.length > 0) {
            selectWrap.find('select-options').mCustomScrollbar('scrollTo', opt.eq(0).position().top);
            opt.eq(0).click();
        }
        needle = '';
    }
}

function styleSelects() {
    var selects = $('select.styled:not(.done)');

    selects.each(function() {
        $(this).wrap('<div class="select-wrap"></div>');
        var wrap = $(this).parent();
        var selected = $(this).find(':selected');
        var def = $(this).find('[data-default="true"]');
        var notdefault = '';
        selected.attr('selected', true);

        if (selected.val() != def.val()) {
            notdefault = true;
        }

        wrap.attr('tabindex', '0');
        wrap.append(
            '<div class="select-value ' +
                (notdefault ? 'selected' : '') +
                '">' +
                (typeof selected.data('background') == 'string'
                    ? '<span class="img" style="background:' + selected.data('background') + '"></span>'
                    : '') +
                selected.text() +
                '</div>'
        );
        var html = '<div class="select-options">';
        $(this).find('option').each(function() {
            html +=
                '<div class="option ' +
                ($(this).attr('selected') ? 'selected' : '') +
                '" data-value="' +
                $(this).val() +
                '" ' +
                ($(this).data('default') ? 'data-default="true"' : '') +
                ' tabindex="0">' +
                (typeof $(this).data('background') == 'string'
                    ? '<span class="img" style="background:' + $(this).data('background') + '"></span>'
                    : '') +
                $(this).text() +
                '</div>';
        });
        html += '</div>';

        wrap.append(html);
        wrap.addClass($(this).attr('class'));
        $(this).addClass('done');

        if ($('.select-options', wrap).outerHeight() >= parseInt($('.select-options', wrap).css('max-height'))) {
            $('.select-options', wrap).mCustomScrollbar({
                scrollInertia: 150
            });
        }
    });
}

(function($) {
    $.fn.countTo = function(options) {
        options = options || {};

        return $(this).each(function() {
            // set options for current element
            var settings = $.extend(
                {},
                $.fn.countTo.defaults,
                {
                    from: $(this).data('from'),
                    to: $(this).data('to'),
                    speed: $(this).data('speed'),
                    refreshInterval: $(this).data('refresh-interval'),
                    decimals: $(this).data('decimals')
                },
                options
            );

            // how many times to update the value, and how much to increment the value on each update
            var loops = Math.ceil(settings.speed / settings.refreshInterval),
                increment = (settings.to - settings.from) / loops;

            // references & variables that will change with each update
            var self = this,
                $self = $(this),
                loopCount = 0,
                value = settings.from,
                data = $self.data('countTo') || {};

            $self.data('countTo', data);

            // if an existing interval can be found, clear it first
            if (data.interval) {
                clearInterval(data.interval);
            }
            data.interval = setInterval(updateTimer, settings.refreshInterval);

            // initialize the element with the starting value
            render(value);

            function updateTimer() {
                value += increment;
                loopCount++;

                render(value);

                if (typeof settings.onUpdate == 'function') {
                    settings.onUpdate.call(self, value);
                }

                if (loopCount >= loops) {
                    // remove the interval
                    $self.removeData('countTo');
                    clearInterval(data.interval);
                    value = settings.to;

                    if (typeof settings.onComplete == 'function') {
                        settings.onComplete.call(self, value);
                    }
                }
            }

            function render(value) {
                var formattedValue = settings.formatter.call(
                    self,
                    value,
                    settings
                );
                $self.html(formattedValue);
            }
        });
    };

    $.fn.countTo.defaults = {
        from: 0, // the number the element should start at
        to: 0, // the number the element should end at
        speed: 1000, // how long it should take to count between the target numbers
        refreshInterval: 100, // how often the element should be updated
        decimals: 0, // the number of decimal places to show
        formatter: formatter, // handler for formatting the value before rendering
        onUpdate: null, // callback method for every time the element is updated
        onComplete: null // callback method for when the element finishes updating
    };

    function formatter(value, settings) {
        return value.toFixed(settings.decimals);
    }
})(jQuery);

jQuery(function($) {
    // custom formatting example
    $('.count-text i').data('countToOptions', {
        formatter: function(value, options) {
            return value
                .toFixed(options.decimals)
                .replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
        }
    });
});

var notcounted = true;

if ($('.count-text i').length > 0) {
    $(document).scroll(function() {
        // start all the timers
        if ($('.count-text i').isOnScreen() == true && notcounted == true) {
            $('.count-text i').each(count);

            function count(options) {
                var $this = $(this);
                options = $.extend(
                    {},
                    options || {},
                    $this.data('countToOptions') || {}
                );
                $this.countTo(options);
            }
            notcounted = false;
        }
    });
}

$.fn.isOnScreen = function() {
    var win = $(window);

    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return !(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top ||
        viewport.top > bounds.bottom
    );
};

function resize() {}
$(document).ready(function() {
    $('#mapTabs .nav-link').on('click', function() {
        newLocation($(this).data('lat'), $(this).data('lng'));
    });
    // return false;
});
var timo;
(window.onresize = function() {
    clearTimeout(timo), (timo = setTimeout(resize, 100));
}),
    $('.navbar-toggler').click(function() {
        $(this).toggleClass('active');
    });

function initGoogleMap(latlng, zoom) {
    var infowindow = new google.maps.InfoWindow({
        content: 'holding...'
    });

    if (typeof $gm === 'undefined') return;
    var styles = [
        {
            stylers: [
                {
                    hue: '#007fff'
                },
                {
                    saturation: 89
                }
            ]
        },
        {
            featureType: 'water',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'administrative.country',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        }
    ];
    var styledMap = new $gm.StyledMapType(styles, { name: 'Styled Map' });

    // Create a map object, and include the MapTypeId to add
    // to the map type control.

    var mapOptions = {
        zoom: zoom,
        center: latlng,
        mapTypeControlOptions: {
            mapTypeIds: [$gm.MapTypeId.ROADMAP, 'map_style']
        }
    };
    var map = new $gm.Map(document.getElementById('map_canvas'), mapOptions);

    map.scrollwheel = false;

    if (typeof map_shops === 'undefined') return;

    for (var i = 0; i < map_shops.length; i++) {
        var shop = map_shops[i];
        //Associate the styled map with the MapTypeId and set it to display.
        map.mapTypes.set('map_style', styledMap);
        map.setMapTypeId('map_style');
        var marker_conf = {
            position: new $gm.LatLng(shop.lat, shop.lng),
            map: map
        };

        if (typeof shop.icon !== 'undefined') {
            var icon = new $gm.MarkerImage(shop.icon, new $gm.Size(25, 25));
            marker_conf.icon = icon;
        }

        var m = new $gm.Marker(marker_conf);

        m.content = shop.content;

        google.maps.event.addListener(m, 'click', function() {
            infowindow.setContent(this.content);
            infowindow.open(map, this);
        });
    }
}

$(document).ready(function() {
    initSelects();
    $(document).scroll();
});

//#endregion mana skripta sākums

$('.feed-carousel').each(function() {
    var carousel = $(this);

    carousel.addClass('owl-carousel').owlCarousel({
        items: 3,
        dots: true,
        scrollBy: 'page',
        loop: true,
        autoplay: true,
        autoplayTimeout: 5000,
        responsiveBaseElement: carousel,
        responsive: {
            0: {
                items: 1,
            },
            740: {
                items: 2
            },
            1024: {
                items: 3
            }
        }
    });
});

$('.offer-carousel').each(function() {
    var carousel = $(this);
    carousel.width(carousel.width());

    carousel.addClass('owl-carousel').owlCarousel({
        items: 1,
        dots: false,
        scrollBy: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 5000,
        responsiveBaseElement: carousel,
    });

    var prevButton = carousel.siblings('.offer-toggler').find('.prev');
    var nextButton = carousel.siblings('.offer-toggler').find('.next');

    prevButton.on('click', function() {
        carousel.trigger('prev.owl.carousel');
        return false;
    });

    nextButton.on('click', function() {
        carousel.trigger('next.owl.carousel');
        return false;
    });
});

$('.page-tree .toggler').click(function() {
    $(this).toggleClass(
        'show',
        !$(this)
            .siblings('.submenu')
            .hasClass('show') && $(this).siblings('.submenu').length > 0
    );
    $(this)
        .siblings('.submenu')
        .collapse('toggle');
});

$(function() {
    $('#fair-brn .content p').each(function() {
        $(this).slabText({
            fontRatio: 0.5,
            viewportBreakpoint: 768
        });
    });
});

$(function () {
    $('header.topline').before('<div id="mobile-menu"><div class="content"></div><div class="overlay"></div></div>');
    var mobileMenu = $('#mobile-menu');
    $('.topline .navbar.top-menu').clone().appendTo($('.content', mobileMenu));
    $('.topline .navbar-expand-lg').prepend('<a href="#" class="menu-toggler"></a>');
    $('.main-menu .blue-menu').clone().appendTo($('.content', mobileMenu));
    $('<div class="bottom-row"></div>').appendTo($('.content', mobileMenu));
    $('.topline .soc-icons').clone().appendTo($('.content .bottom-row', mobileMenu));
    $('.topline .search-wrap + .align-items-center').clone().appendTo($('.content .bottom-row', mobileMenu));
});

$(document).on('click', '.menu-toggler', function () {
    $('#mobile-menu').toggleClass('show');
});

$(document).on('click', '.overlay', function () {
    $('#mobile-menu').removeClass('show');
});